import { render, staticRenderFns } from "./WaybillAddressChange.vue?vue&type=template&id=785995bf&scoped=true"
import script from "./WaybillAddressChange.vue?vue&type=script&lang=js"
export * from "./WaybillAddressChange.vue?vue&type=script&lang=js"
import style0 from "./WaybillAddressChange.vue?vue&type=style&index=0&id=785995bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785995bf",
  null
  
)

export default component.exports